import React from 'react';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import Footer from './Footer';
import Header from './Header';
import MaterialUiTheme from '../shared/components/MaterialUiTheme';
import NavigationMenu from './navigation-menu/NavigationMenu';

/**
 * @typedef {object} LayoutProps
 * @property {Array<React.ReactElement>|Object} [children]
 * @property {boolean} [showMenu]
 */

/**
 * @param {LayoutProps} props
 */
const Layout = props => {
  const { children, showMenu = true } = props;

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={MaterialUiTheme}>
        <div id='layout'>
          <Header showMenuIcon={showMenu} />
          {showMenu ? <NavigationMenu /> : null}
          <div id='flex-wrapper'>
            <div id='body'>{children}</div>
            <Footer />
          </div>
        </div>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default Layout;
